module.exports = __webpack_public_path__ + "img/teae.88338418.png";